import create from "zustand";

interface ProcessStore {
    data?: any | null;
    setData: (data: any | null | undefined) => void;
}

export const useProcessStore = create<ProcessStore>((set) => ({
    data: null,
    setData: (data: any) => set({ data }),
}));
